<template>
  <div class="nav-bar">
    <a class="collapse-btn" @click="ToggleSideBar()">
      <svg-icon icon-class="collapse" />
    </a>
    <div class="nav-right">
      <!-- 联系客服 -->
      <a 
        class="service"
        @click="$refs.wechatQrCode.show()">
        <svg-icon icon-class="wechat" />
        联系客服
      </a>
      <!-- 用户 -->
      <div class="user-info">
        <el-dropdown trigger="click" @command="command => userinfoCommand(command)">
          <span>
            <img 
              v-if="userinfo" 
              :src="userinfo.avatar"
              class="avatar" />
            {{username}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">
              登出
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <WechatQrCode
      ref="wechatQrCode" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { withLoadingApi } from '@/utils/hoc'
import { Logout } from '@/api'
import WechatQrCode from './WechatQrCode'
export default {
  name: 'default',
  data () {
    return {
      logoutLoading: false
    }
  },
  computed: {
    ...mapGetters(['userinfo']),
    username(){
      if(this.logoutLoading)
        return '登出中...'
      return this.userinfo ? this.userinfo.nickname: '请登录'
    }
  },
  components: {
    WechatQrCode
  },
  methods: {
    ...mapActions(['ToggleSideBar', 'LogOut']),
    userinfoCommand(command){
      switch(command){
        case 'logout':
          withLoadingApi(
            Logout(),
            'logoutLoading',
            this
          ).finally(() => {
            this.LogOut();
            this.$message.success('您已登出账户');
            this.$nextTick(() => location.reload())
          })
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .collapse-btn{
    width: 22px;
    height: 22px;
    font-size: 24px;
    margin: 0px 10px;
  }
  .nav-right{
    display: flex;
    align-items: center;
    height: 50px;
    padding-right: 3%;
    & > *{
      margin-left: 20px;
    }
    .user-info{
      >>> .el-dropdown-selfdefine{
        display: flex;
        align-items: center;
        cursor: pointer;
        position: relative;
        padding-left: 38px;
        .avatar{
          height: 30px;
          width: 30px;
          object-fit: cover;
          border-radius: 100%;
          @extend .abs-midY;
          left: 0;
          box-shadow: 1px 1px 1px 1px rgba(0,0,0,.1);
        }
      }
    }
    .service{
      font-size: 14px;
      color: $text2;
      display: flex;
      align-items: center;
      .svg-icon{
        color: $theme-color;
        font-size: 20px;
        margin-right: 5px;
      }
      &:hover{
        color: $text1;
      }
    }
    @extend .clearfix;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Navbar/index.vue